<template>
    <div class="modal-Baidu">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">地图搜索定位</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <div class="app-container">
                    <div style="margin: 5px">
                        <baidu-map
                            class="bm-view"
                            :zoom="12"
                            :scroll-wheel-zoom="true"
                            @click="getClickInfo">
                            <bm-view style="width: 100%; height:500px;"></bm-view>
                                <bm-marker
                                    :position="{ lng: centerStr.lng, lat: centerStr.lat }"
                                    :dragging="true"
                                    animation="BMAP_ANIMATION_BOUNCE">
                                </bm-marker>
                            <bm-control :offset="{ width: '10px', height: '10px'}">
                                <bm-auto-complete v-model="addressInfo" :sugStyle="{ zIndex: 999999 }">
                                    <el-input v-model="addressInfo" placeholder="请输入搜索关键字" style="margin:10px 0 0 10px">
                                        <template slot="prepend"><span>地址搜索：</span></template>
                                    </el-input>
                                </bm-auto-complete>
                            </bm-control>
                            <bm-local-search
                                :keyword="addressInfo"
                                :auto-viewport="true"
                                style="width:0px;height:0px;overflow: hidden;">
                            </bm-local-search>
                        </baidu-map>
                    </div>
                    
                </div>
            </div>
            <div class="modal-footer">
                <el-row style="width:100%">
                    <el-col :span="21">
                        <el-col :span="12" style="padding:0 5px ">
                            <el-input v-model="addressInfo" disabled>
                                <template slot="prepend"><span>所选地址：</span></template>
                            </el-input>
                        </el-col>
                        <el-col :span="12" style="padding:0 5px ">
                            <el-input v-model="address" >
                                <template slot="prepend"><span>详细地址：</span></template>
                            </el-input>
                        </el-col>
                    </el-col>
                    <el-col :span="3">
                        <el-button style="float: right;margin-right:10px" type="primary" @click="confirm('addForm')">添加</el-button>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
export default {
    name: "addHospital",
    data() {
        return {
            mapZoom: 15,
            mapCenter: { lng: 0, lat: 0 },
            addressInfo:'',
            door:'',
            initCity:'',
            address:'',
            centerName:'',
            mapLocation: {
                address: undefined,
                coordinate: undefined
            },
            keyword: "",
            centerStr: {
                lng: "",
                lat: ""
            }
        };
    },
    components: {
        BaiduMap
    },
    methods: {
        closeSelf(){
            this.$emit('colseMap')
        },
        getClickInfo(e) {
            this.centerStr.lng = e.point.lng;
            this.centerStr.lat = e.point.lat;
        },
        init(){
            this.mapLocation.address=undefined
            this.addressInfo=undefined
            this.address=undefined
        },
        confirm(){
            if(!this.addressInfo){
                this.$message({type: 'info', message: '请选择地址'});
                return;
            }
            if(!this.address){
                this.$message({type: 'info', message: '请输入详情地址'});
                return;
            }
            var mapCenter={
                lng: this.centerStr.lng, lat:this.centerStr.lat,addressInfo:this.addressInfo+this.address
            }
            console.log(mapCenter)
            this.$emit('setMap',mapCenter)
        }
  }
};

</script>




<style lang="scss" scoped>
    .map {
        width: 100%;
        height: 450px;
    }
    .modal-Baidu {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 800px;
            height: 660px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .bm-view {
                width: 100%;
                height: 430px;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height:500px;
            }
            .modal-body .search{
                position: fixed;
                z-index: 2;
                max-height: 450px;
                width: 250px;
                overflow-y:scroll;
                margin-left: 100px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                // justify-content: flex-end;
                padding: 15px;
                // display: flex;
            }
            .uploadButton{
                border-top: 1px solid #eee;
                padding: 10px 0 0;
                display: flex;
                 .el-button{
                    width: 100px;
                }
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
